import { IOfferReactionSchema } from '../../repositories/cian-chat-bot/entities/offer_reaction/OfferReactionSchema';
import {
  fetchPublicMobileV1SetOfferReaction,
  TPublicMobileV1SetOfferReactionResponse,
} from '../../repositories/cian-chat-bot/mobile/v1/set-offer-reaction';
import { TContext } from '../../types/context';

type TChatbotSetOfferReactionContext = Pick<TContext, 'httpApi' | 'logger'>;

export async function chatbotSetOfferReaction(
  { httpApi, logger }: TChatbotSetOfferReactionContext,
  parameters: IOfferReactionSchema,
): Promise<boolean> {
  try {
    const { response, statusCode }: TPublicMobileV1SetOfferReactionResponse = await fetchPublicMobileV1SetOfferReaction(
      {
        httpApi,
        parameters,
      },
    );

    if (statusCode !== 200) {
      logger.warning('Код ответа не 200', {
        message: 'Не удалось сохранить лайк/дизлайк',
        domain: 'src/shared/services/chatbotSetOfferReaction/chatbotSetOfferReaction.ts [chatbotSetOfferReaction]',
        statusCode,
        messsage: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });

      return false;
    }

    return true;
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/chatbotSetOfferReaction/chatbotSetOfferReaction.ts [chatbotSetOfferReaction]',
      message: 'Не удалось сохранить лайк/дизлайк',
    });

    return false;
  }
}
